import ActivityCodes from './ActivityCodes'
import User from './User'
import Project from './Project'
export default class ProjectBudgetedHours {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //ProjectID is required
      ProjectID: 0,
      //ActivityID is required
      ActivityID: 0,
      StandardBudgetHours: null,
      //BudgetedHours is required
      BudgetedHours: 0,
      Comments: null,
      //Approved is required
      Approved: false,
      ApprovedBy: null,
      ApprovalDate: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.ProjectID = obj.ProjectID
    this.ActivityID = obj.ActivityID
    this.StandardBudgetHours = obj.StandardBudgetHours
    this.BudgetedHours = obj.BudgetedHours
    this.Comments = obj.Comments
    this.Approved = obj.Approved
    this.ApprovedBy = obj.ApprovedBy
    this.ApprovalDate = obj.ApprovalDate

    this.Activity = new ActivityCodes(obj.Activity || {})
    this.ApprovedByNavigation = new User(obj.ApprovedByNavigation || {})
    this.Project = new Project(obj.Project || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Activity = null
    obj.ApprovedByNavigation = null
    obj.Project = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Activity = null
    obj.ApprovedByNavigation = null
    obj.Project = null
    return obj
  }
}
